import { render, staticRenderFns } from "./template1.vue?vue&type=template&id=920c822a&"
import script from "./template1.vue?vue&type=script&lang=js&"
export * from "./template1.vue?vue&type=script&lang=js&"
import style0 from "./template1.vue?vue&type=style&index=0&id=920c822a&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('920c822a')) {
      api.createRecord('920c822a', component.options)
    } else {
      api.reload('920c822a', component.options)
    }
    module.hot.accept("./template1.vue?vue&type=template&id=920c822a&", function () {
      api.rerender('920c822a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/renovation/template1.vue"
export default component.exports